import React, { createContext, useEffect, useReducer } from "react";


export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { candidate: action.payload };
    case "LOGOUT":
      return { candidate: null };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    candidate: null,
  });

  useEffect(() => {
    const candidate = JSON.parse(localStorage.getItem("candidate"));

    if (candidate && Date.now() < candidate.expiry) {
      dispatch({ type: "LOGIN", payload: candidate });
    } else {
      localStorage.removeItem("candidate");
    }
  }, []);

  console.log("AuthContext state:", state);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};